export const truncatedValue = (value, maxDecimals) => {
    const numberOfDecimals = (value.split('.')[1] || '').length;
    const decimalIndex = value.indexOf('.');
    const truncatedValue = value.slice(0, decimalIndex + 1 + maxDecimals);
    return numberOfDecimals > maxDecimals ? truncatedValue : value;
};
//# sourceMappingURL=truncatedValue.js.map